import React from "react";

//Styles
import "./NeedMoreHelp.scss";

//Data
import { needMoreHelpExampleData } from "./exampleData";

function NeedMoreHelp() {
  const { telephone, telephoneText } = needMoreHelpExampleData;
  return (
    <section className="page-landing more-help">
      <h2>
        <span role="img" aria-label="Waving hand emoji">
          👋
        </span>{" "}
        Need more help?
      </h2>
      <p>We are here to help you set up your design contest or to hire a designer 1 on 1.</p>
      <div className="phone-and-request">
        <a href={`tel:${telephone}`}>
          <span role="img" aria-label="Telephone emoji">
            📞
          </span>{" "}
          {telephoneText}
        </a>
        <a href="/consultation-request">
          <span role="img" aria-label="Speech bubble emoji">
            💬
          </span>{" "}
          Request Free Consultation
        </a>
      </div>
    </section>
  );
}

export default NeedMoreHelp;
